import React, { useEffect, useState, useRef } from "react";
import { ErrorMessage, useFormik, FormikProvider, Form, Field } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CustomInput from "../../../CustomControls/CustomInput";
import { Button, Col, Row, Modal } from "react-bootstrap"; // Update import for Modal
import { Spin } from "antd";

import "react-dropzone-uploader/dist/styles.css";
import * as Yup from "yup";
import { SVGICON } from "../../../constant/theme";
import { Link, useNavigate } from "react-router-dom";
import {
  POST_GetCustomerContactPersonsList,
  POST_BroadcastMessageSend,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";

import {
  successMessage,
  errorMessage,
  warningMessage,
  capitalizeString,
  cleanCsvString,
  validateEmail,
} from "../CommonFunctions";

const BroadcastMessage = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const fileInputRef = useRef(null);

  const [checkedItems, setCheckedItems] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [initialList, setInitialList] = useState([]);

  const validationSchema = Yup.object({
    Subject: Yup.string().required("Subject is required"),
    EmailEditor: Yup.string().required("Email body is required"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values) => {
      handleValidSubmit(values);
    },

    initialValues: {
      Subject: "",
      EmailEditor: "",
      attachment: "",
      sentToAll: true,
      Selected: false,
      AdditionalEmailID: "",
    },

    validateOnBlur: false,
  });

  const formikData = useFormik({
    // validationSchema,
    onSubmit: (values) => {},
    initialValues: {
      CustomerNameSearch: "",
      ContactPersonSearch: "",
      MobileNoSearch: "",
      EmailIDSearch: "",
      ListofBroadcast: [],
      // sentToAll: true,
      // Selected: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      EmailIDSearch,
      ContactPersonSearch,
      MobileNoSearch,
      CustomerNameSearch,
      ListofBroadcast,
    },
  } = formikData;

  const handleSentToAllChange = (event) => {
    const { checked } = event.target;
    formik.setFieldValue("sentToAll", checked);
    if (checked) {
      const updatedList = ListofBroadcast.map((item) => ({
        ...item,
        IsSelected: false, // Uncheck all items
      }));
      formikData.setFieldValue("ListofBroadcast", updatedList);
      formik.setFieldValue("Selected", false);
    }
    //handleListOfBroadcastTouched();
  };

  const handleSelectedChange = (event) => {
    const { checked } = event.target;
    formik.setFieldValue("Selected", checked);
    if (checked) {
      formik.setFieldValue("sentToAll", false);
      setInitialList([...formikData.values.ListofBroadcast]);
      setModalVisible(true);
    } else {
      const updatedList = ListofBroadcast.map((item) => ({
        ...item,
        IsSelected: false, // Uncheck all items
      }));
      formikData.setFieldValue("ListofBroadcast", updatedList);
      setModalVisible(false);
    }
    //handleListOfBroadcastTouched();
  };

  // const handleListOfBroadcastTouched = () => {
  //   if (formik.values.sentToAll && formik.values.Selected) {
  //     formik.setFieldTouched("ListofBroadcast", true);
  //   } else {
  //     const updatedList = ListofBroadcast.map((item) => ({
  //       ...item,
  //       IsSelected: false, // Uncheck all items
  //     }));
  //     formikData.setFieldValue("ListofBroadcast", updatedList);
  //     formik.setFieldTouched("ListofBroadcast", false);
  //   }
  // };

  const CancelModal = () => {
    formikData.setFieldValue("ListofBroadcast", initialList);

    setModalVisible(false);
  };

  const submitData = () => {
    const selectedData = formikData.values.ListofBroadcast.filter(
      (item) => item.IsSelected
    );

    const selectedEmails = selectedData.map((item) => item.EmailID);

    setSelectedEmails(selectedEmails);

    formikData.setFieldValue("ListofBroadcast", selectedData);

    // Update the main list with the current state of selections
    formikData.setFieldValue("ListofBroadcast", [...ListofBroadcast]);

    // Close the modal
    setModalVisible(false);
  };

  const handleCheckbox = (index) => {
    // kaya number ni email is check thay te show karse
    const updatedCheckedItems = checkedItems || [];
    updatedCheckedItems[index] = !updatedCheckedItems[index];
    setCheckedItems(updatedCheckedItems);

    const EmailID = ListofBroadcast[index]?.EmailID; // Use optional

    if (EmailID) {
      if (updatedCheckedItems[index]) {
        setSelectedEmails((prev) => {
          if (!prev.includes(EmailID)) {
            const newEmails = [...prev, EmailID];

            return newEmails;
          }
          return prev;
        });
      } else {
        setSelectedEmails((prev) => {
          const newEmails = prev.filter((e) => e !== EmailID);

          return newEmails;
        });
      }
      // Update formik's ListofBroadcast IsSelected
      formikData.setFieldValue(
        `ListofBroadcast[${index}].IsSelected`,
        updatedCheckedItems[index]
      );
      formikData.setFieldTouched("ListofBroadcast", false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setAttachment(null);
      return;
    }

    if (file) {
      const maxFileSize = 25 * 1024 * 1024;

      if (file.size > maxFileSize) {
        warningMessage("Maximum file size 25MB.");

        event.target.value = null;
        setAttachment(null);
      } else {
        setAttachment(file);
      }
    }
  };

  const handleDeleteImage = () => {
    setAttachment(null);
    fileInputRef.current.value = "";
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async (page = 1, sizePerPage = 50) => {
    setIsLoading(true);

    const payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CustomerName: CustomerNameSearch,
      ContactPerson: ContactPersonSearch,
      MobileNo: MobileNoSearch,
      EmailID: EmailIDSearch,
    };

    await post(POST_GetCustomerContactPersonsList, payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.IsSuccess) {
          formikData.setFieldValue(
            "ListofBroadcast",
            response?.List.map((item) => ({
              CustomerName: item.CustomerName,
              ContactPerson: item.ContactPerson,
              Designation: item.Designation,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              display: true,
              IsSelected: false,
              IsBilling: item.IsBilling,
              IsReporting: item.IsReporting,
              IsDispatch: item.IsDispatch,
              IsDispatchMaterial: item.IsDispatchMaterial,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleChangeSearchProcessName = (
    CustomerNameSearch,
    ContactPersonSearch,
    MobileNoSearch,
    EmailIDSearch
  ) => {
    setIsLoading(true);

    const payload = {
      CurrentPage: 1,
      PageSize: 50,
      CustomerName: CustomerNameSearch,
      ContactPerson: ContactPersonSearch,
      MobileNo: MobileNoSearch,
      EmailID: EmailIDSearch,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    };

    post(POST_GetCustomerContactPersonsList, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          //setRecordCount(response?.TotalRecordCount);

          let selectedItems = ListofBroadcast?.filter(
            (x) => x.IsSelected === true
          );

          // Filter out already selected items from the API response
          let filteredItems = response?.List.filter(
            (item) =>
              !ListofBroadcast?.find(
                (Item) =>
                  Item.CustomerName === item.CustomerName &&
                  Item.ContactPerson === item.ContactPerson &&
                  Item.MobileNo === item.MobileNo &&
                  Item.EmailID === item.EmailID &&
                  Item.IsSelected
              )
          ).map((item) => ({
            ...item,
            display: true,
            IsSelected: false,
          }));

          // Combine the selected items with the new filtered items from the API response
          formikData.setFieldValue("ListofBroadcast", [
            ...selectedItems,
            ...filteredItems,
          ]);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleValidSubmit = async (values) => {
    let listOfAdditionalEmails = values?.AdditionalEmailID?.trim()
      ? cleanCsvString(values?.AdditionalEmailID)?.split(",")
      : [];

    if (
      values?.sentToAll == false &&
      values.Selected == false &&
      listOfAdditionalEmails?.length == 0
    ) {
      warningMessage(
        "Please select any one option: Send to All/Selected/AdditionalEmails"
      );
      return;
    }

    if (values?.Selected == true) {
      if (ListofBroadcast?.filter((x) => x.IsSelected == true)?.length == 0) {
        warningMessage("Please select contact person email to send!");
        return;
      }
    }

    if (
      listOfAdditionalEmails?.length > 0 &&
      listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)?.length >
        0
    ) {
      formik.setFieldError(
        "AdditionalEmailID",
        "Please check it contains invalid email address"
      );
      formik.setFieldTouched("AdditionalEmailID", true);

      return;
    }
    //setIsLoading(true);
    let formData = new FormData();
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("CreatedByEncrypted", AuthUser?.ReferenceIDEncrypt);
    formData.append("Subject", values.Subject);
    formData.append("EmailBody", values.EmailEditor);

    formData.append("AttachmentFile", attachment);

    let emailCsv = "";
    //let emailIDs = [...new Set(selectedEmails)];

    selectedEmails?.map((x) => {
      emailCsv = emailCsv + x + ", ";
    });

    if (listOfAdditionalEmails) {
      listOfAdditionalEmails?.map((email) => {
        emailCsv = emailCsv + email + ", ";
      });
    }
    emailCsv = cleanCsvString(emailCsv);

    formData.append("EmailIDs", emailCsv);

    if (values.sentToAll) {
      formData.append("IsSelectedAll", true);
    } else {
      formData.append("IsSelectedAll", false);
    }

    await postFormData(POST_BroadcastMessageSend, formData)
      .then((response) => {
        setIsLoading(false);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked; // Get the checked state of the header checkbox

    const updatedList = ListofBroadcast.map((item) => ({
      ...item,
      IsSelected: isChecked, // Set the IsSelected property to the header checkbox's state
    }));

    formikData.setFieldValue("ListofBroadcast", updatedList);
  };

  const handleOpenModal = () => {
    formikData.setFieldValue("CustomerNameSearch", "");
    formikData.setFieldValue("ContactPersonSearch", "");
    formikData.setFieldValue("MobileNoSearch", "");
    formikData.setFieldValue("EmailIDSearch", "");
    // // Call your search function with empty values if needed
    handleChangeSearchProcessName();

    setInitialList([...formikData.values.ListofBroadcast]);

    setModalVisible(true);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Broadcast Message</h4>
          </div>
          <hr className="mt-0 mb-1" />
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={7}>
                    <Field
                      label="Subject"
                      placeholder="Subject"
                      name="Subject"
                      component={CustomInput}
                      required
                      className="w-100"
                      onChange={(e) => {
                        formik.setFieldValue("Subject", capitalizeString(e));
                      }}
                    />
                  </Col>

                  <Col xs={12} sm={12} md={12} lg={7} className="mb-2">
                    <div className="custom-ekeditor">
                      <label>Email Body</label>
                      <span className="text-danger"> *</span>
                      <CKEditor
                        editor={ClassicEditor}
                        config={{
                          toolbar: [
                            "heading",
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "indent",
                            "outdent",
                            "insertTable",
                            "blockQuote",
                            // "imageUpload",
                            "undo",
                            "redo",
                          ],
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          formik.setFieldValue("EmailEditor", data); // Update Formik's state
                          const dataWithBorders = data
                            .replace(
                              /<table([^>]*)>/g,
                              '<table style="border: 1px solid black; border-collapse: collapse;">'
                            )
                            .replace(
                              /<td([^>]*)>/g,
                              '<td style="border: 1px solid black; padding: 5px;">'
                            )
                            .replace(
                              /<th([^>]*)>/g,
                              '<th style="border: 1px solid black; padding: 5px;">'
                            );

                          // Save the modified HTML with borders back into Formik
                          formik.setFieldValue("EmailEditor", dataWithBorders); // Replace with your form handling method
                        }}
                        onReady={(editor) => {
                          editor.keystrokes.set(
                            "enter",
                            (keyEvtData, cancel) => {
                              // Allow default behavior to execute
                              editor.execute("enter");
                              cancel(); // Prevent default behavior to execute custom logic if needed
                            }
                          );

                          editor.keystrokes.set(
                            "shift+enter",
                            (keyEvtData, cancel) => {
                              //console.log("Shift + Enter pressed");
                              cancel(); // Prevent default behavior
                              editor.model.change((writer) => {
                                const selection =
                                  editor.model.document.selection;
                                const position = selection.getFirstPosition();
                                writer.insertElement("softBreak", position);
                                writer.setSelection(position.getShiftedBy(1));
                              });
                            }
                          );
                        }}
                        onBlur={(event, editor) => {}}
                        onFocus={(event, editor) => {}}
                      />

                      <ErrorMessage
                        style={{ fontSize: "0.875em" }}
                        name="EmailEditor"
                        component="div"
                        className="mt-1 text-danger animated fadeInUp"
                      />
                    </div>
                  </Col>

                  <Col lg={7} className="mb-2">
                    <div className="d-flex justify-content-between">
                      <label name="Attachment" htmlFor="imageUrl">
                        Attachment
                      </label>
                      <br />
                      {attachment && (
                        <Link
                          to="#"
                          title="Delete"
                          className="fs-14"
                          onClick={handleDeleteImage}
                        >
                          {SVGICON.DeleteDanger}
                        </Link>
                      )}
                    </div>
                    <input
                      className="form-control"
                      type="file"
                      name="Attachment"
                      onChange={handleFileChange}
                      ref={fileInputRef}
                    />
                  </Col>

                  <Col lg={7} className="mb-2">
                    <label>
                      <span className="form-check-label me-2">Send to all</span>
                      <Field
                        type="checkbox"
                        name="sentToAll"
                        className="form-check-input"
                        // checked={formik.values.sentToAll}
                        onChange={handleSentToAllChange}
                      />
                    </label>
                    <label>
                      <span className="form-check-label ms-2 me-2">
                        Selected
                      </span>
                      <Field
                        type="checkbox"
                        name="Selected"
                        className="form-check-input"
                        onChange={handleSelectedChange}
                        // checked={formik.values.Selected}
                      />
                    </label>
                    {formik.values.Selected && (
                      <Link className="ms-3 me-2" onClick={handleOpenModal}>
                        <i>
                          <u>Select Contact Person</u>
                        </i>
                      </Link>
                    )}

                    <ErrorMessage
                      name="ListofBroadcast"
                      component="div"
                      className="mt-1 text-danger animated fadeInUp"
                      style={{ fontSize: "0.875em" }}
                    />
                  </Col>

                  <Col lg={7}>
                    <Field
                      label="Additional EmailID"
                      placeholder="Additional EmailID"
                      name="AdditionalEmailID"
                      component={CustomInput}
                      // required
                      className="w-100"
                    />
                  </Col>

                  <hr className="mb-2" />

                  <Col xs={12} className="mb-2">
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Send Email
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>

      <Modal
        size="xl"
        show={modalVisible}
        onHide={() => {
          setModalVisible(false);
          CancelModal();
        }}
      >
        <Modal.Header>
          <Modal.Title>Select Contact Person</Modal.Title>
          <Button
            type="button"
            variant=""
            className="btn-close"
            onClick={() => CancelModal()}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <FormikProvider value={formikData}>
            <Form onSubmit={formikData.handleSubmit}>
              <Row>
                <Col lg={12}>
                  <label style={{ color: "red", fontSize: "0.875em" }}>
                    Note : By default 50 records will be display from the
                    remaining searching.
                  </label>
                  <div className="table-responsive active-projects style-1 shorting">
                    <div
                      id="VendorProcessDetail-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="VendorProcessDetail-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="2%" className="p-1"></th>
                            <th width="29%" className="p-1">
                              Customer
                            </th>
                            <th width="23%" className="p-1">
                              Person
                            </th>
                            <th width="23%" className="p-1">
                              Contact
                            </th>
                            <th
                              width="23%"
                              className="p-1"
                              style={{ textAlign: "left" }}
                            >
                              Email
                            </th>
                          </tr>
                          <tr>
                            <th width="2%" className="p-1 pt-0">
                              <input
                                type="checkbox"
                                className="form-check-input ms-1"
                                onClick={handleSelectAll}
                                checked={ListofBroadcast?.every(
                                  (item) => item.IsSelected
                                )}
                              />
                            </th>
                            <th width="29%" className="p-1 pt-0">
                              <Field
                                name="CustomerNameSearch"
                                placeholder={"Search CustomerName"}
                                component={CustomInput}
                                required
                                maxLength={100}
                                noMarginBottom={true}
                                style={{ height: "2.3rem" }}
                                className="custom-input-class"
                                onChange={(e) => {
                                  formikData.setFieldValue(
                                    "CustomerNameSearch",
                                    e?.target?.value ?? ""
                                  );
                                  handleChangeSearchProcessName(
                                    e?.target?.value ?? "",
                                    ContactPersonSearch
                                      ? ContactPersonSearch
                                      : "",
                                    MobileNoSearch ? MobileNoSearch : "",
                                    EmailIDSearch ? EmailIDSearch : ""
                                  );
                                }}
                              />
                            </th>
                            <th width="23%" className="p-1 pt-0">
                              <Field
                                name="ContactPersonSearch"
                                placeholder={"Search ContactPerson"}
                                component={CustomInput}
                                required
                                maxLength={100}
                                noMarginBottom={true}
                                style={{ height: "2.3rem" }}
                                // className="custom-input-class"
                                onChange={(e) => {
                                  formikData.setFieldValue(
                                    "ContactPersonSearch",
                                    e?.target?.value ?? ""
                                  );
                                  handleChangeSearchProcessName(
                                    CustomerNameSearch
                                      ? CustomerNameSearch
                                      : "",
                                    e?.target?.value ?? "",
                                    MobileNoSearch ? MobileNoSearch : "",
                                    EmailIDSearch ? EmailIDSearch : ""
                                  );
                                }}
                              />
                            </th>
                            <th width="23%" className="p-1 pt-0">
                              <Field
                                name="MobileNoSearch"
                                placeholder={"Search MobileNo"}
                                component={CustomInput}
                                required
                                maxLength={100}
                                noMarginBottom={true}
                                style={{ height: "2.3rem" }}
                                // className="custom-input-class"
                                onChange={(e) => {
                                  formikData.setFieldValue(
                                    "MobileNoSearch",
                                    e?.target?.value ?? ""
                                  );
                                  handleChangeSearchProcessName(
                                    CustomerNameSearch
                                      ? CustomerNameSearch
                                      : "",
                                    ContactPersonSearch
                                      ? ContactPersonSearch
                                      : "",
                                    e?.target?.value ?? "",
                                    EmailIDSearch ? EmailIDSearch : ""
                                  );
                                }}
                              />
                            </th>
                            <th width="23%" className="p-1 pt-0">
                              <Field
                                name="EmailIDSearch"
                                placeholder={"Search EmailID"}
                                component={CustomInput}
                                required
                                maxLength={100}
                                noMarginBottom={true}
                                style={{ height: "2.3rem" }}
                                // className="custom-input-class"
                                onChange={(e, index) => {
                                  formikData.setFieldValue(
                                    "EmailIDSearch",
                                    e?.target?.value ?? ""
                                  );

                                  handleChangeSearchProcessName(
                                    CustomerNameSearch
                                      ? CustomerNameSearch
                                      : "",
                                    ContactPersonSearch
                                      ? ContactPersonSearch
                                      : "",
                                    MobileNoSearch ? MobileNoSearch : "",
                                    e?.target?.value ?? ""
                                  );
                                }}
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListofBroadcast?.filter((x) => x.display === true)
                            ?.length > 0 ? (
                            ListofBroadcast?.map((item, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: item.display === true ? "" : "none",
                                }}
                              >
                                <td style={{ minWidth: "50px" }}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`chkProcess${index}`} // Use curly braces for template literals
                                    name={`chkProcess${index}`} // Use curly braces for template literals
                                    checked={item.IsSelected}
                                    onChange={(e) => {
                                      formikData.setFieldValue(
                                        `ListofBroadcast[${index}].IsSelected`, // Update the correct value for IsSelected
                                        e?.target?.checked
                                      );
                                      handleCheckbox(index); // Handle checkbox change
                                    }}
                                  />
                                </td>
                                <td style={{ minWidth: "200px" }}>
                                  {item.CustomerName}
                                </td>
                                <td style={{ minWidth: "180px" }}>
                                  {item.ContactPerson}
                                </td>
                                <td style={{ minWidth: "125px" }}>
                                  {item.MobileNo}
                                </td>
                                <td
                                  style={{
                                    minWidth: "200px",
                                    textAlign: "left",
                                  }}
                                >
                                  {item.EmailID}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={8}
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <div>{"No options"}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          </FormikProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={submitData} variant="primary btn-sm">
            <i className="fa-solid fa-floppy-disk"></i> Submit
          </Button>
          <Button onClick={CancelModal} variant="danger btn-sm">
            <i className="fa fa-cancel"></i> Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BroadcastMessage;
